import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useMutation, useQuery } from "react-query";
import {
  deleteSuperAdmin,
  loadSuperAdmins,
} from "../../../queries/admin/superAdmin";
import ReactPaginate from "react-paginate";
import { removeItem } from "../../../redux/reducers/helpers";
import { useErrorHandler } from "react-error-boundary";
import PropTypes from "prop-types";

const SuperAdminsPage = ({ queryClient }) => {
  const handleError = useErrorHandler();
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchSuperAdmins = async (page = 1) =>
    loadSuperAdmins(page)
      .then((data) => {
        setTotalPages(data?.meta?.total_pages || 0);
        setPage(data?.meta?.page || 1);
        return data.results;
      })
      .catch((error) => {
        handleError(error);
      });

  const {
    isLoading,
    isError,
    data: superAdmins,
    isPreviousData,
  } = useQuery(
    ["superAdmins", page],
    () =>
      fetchSuperAdmins(page).then((data) => {
        return data;
      }),
    {
      keepPreviousData: true,
    }
  );

  const destroySuperAdmin = useMutation(async (superAdmin) => {
    if (
      confirm(`Are you sure that you want to delete ${superAdmin.fullName} ?`)
    ) {
      return deleteSuperAdmin(superAdmin.id).then((data) => {
        queryClient.setQueryData(
          ["superAdmins", page],
          removeItem(superAdmins, data)
        );
      });
    }
  });

  const handlePageClick = (e) => {
    if (!isPreviousData) {
      setPage(e.selected + 1);
    }
  };

  return (
    <div className="container">
      <div className="d-flex align-items-center mb-45">
        <h3 className="m-0">Super Admins</h3>
        <Link
          to="/super-admins/new"
          className="btn btn-sm btn-main nowrap ml-auto"
        >
          Create New
        </Link>
      </div>

      <table className="table-list text-small">
        <thead>
          <tr>
            <th>NAME</th>
            <th>EMAIL</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {!isLoading && !isError && (
            <>
              {superAdmins.map((superAdmin) => (
                <tr key={superAdmin.id}>
                  <td>
                    <h5 className="text-small m-0">{superAdmin.fullName}</h5>
                  </td>
                  <td>
                    <a href="mailto:<?php echo $email; ?>">
                      {superAdmin.email}
                    </a>
                  </td>
                  <td className="table-actions nowrap">
                    <Link
                      to={`/super-admins/${superAdmin.id}/edit`}
                      className="btn-transparent btn-icon ml-n2 ml-md-0"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Edit"
                    >
                      <i className="icon-edit" />
                    </Link>
                    <a
                      href=""
                      className="btn-transparent btn-icon"
                      data-tooltip="tooltip"
                      data-placement="top"
                      title="Force password reset"
                      data-toggle="modal"
                      data-target="#password-reset-modal"
                    >
                      <i className="icon-password-reset" />
                    </a>
                    <a
                      className="btn-transparent btn-icon"
                      data-tooltip="tooltip"
                      data-placement="top"
                      title="Delete"
                      data-toggle="modal"
                      data-target="#delete-modal"
                      onClick={() =>
                        destroySuperAdmin.mutate({
                          id: superAdmin.id,
                          fullName: superAdmin.fullName,
                        })
                      }
                    >
                      <i className="icon-delete" />
                    </a>
                  </td>
                </tr>
              ))}
            </>
          )}
        </tbody>
      </table>

      {totalPages > 1 && !isLoading && (
        <ReactPaginate
          onPageChange={(e) => handlePageClick(e)}
          previousLabel={"<"}
          nextLabel={">"}
          breakLabel={"..."}
          pageCount={totalPages}
          pageRangeDisplayed={totalPages}
          marginPagesDisplayed={2}
          containerClassName={"pagination mt-45"}
          activeClassName={"active"}
          activeLinkClassName={"current"}
        />
      )}
    </div>
  );
};

SuperAdminsPage.propTypes = {
  queryClient: PropTypes.object.isRequired,
};

export default SuperAdminsPage;
